module.exports = __webpack_public_path__ + "img/Jump Casting74.97b17b23.jpg";